import { Helmet } from 'react-helmet';

const defaultDescription = "Pancakeswap predictions alternative. " +
  "A peer-to-peer wagering dApp on BSC. Fair, accurate prediction gaming. " +
  "Simple rules to play, too! Bet up or down and win if you guessed correctly";

function Metadata(props) {
  return (
    <Helmet>
      <meta charSet='utf-8' />
      <title>{props.title} | DogeBets</title>
      <link rel='canonical' href={'https://dogebets.gg' + props.link} />
      <meta name='description' content={props.description} />
      <meta property='og:title' content={`${props.title} | DogeBets`} data-rh='true' />
      <meta property='og:description' content={props.description || defaultDescription} data-rh='true' />
    </Helmet>
  );
}

export default Metadata;
